<script setup>
import { computed } from 'vue';
import { useMapGetter } from 'dashboard/composables/store.js';
import {
  resolveActionName,
  resolveTeamIds,
  resolveLabels,
  resolveAgents,
} from 'dashboard/routes/dashboard/settings/macros/macroHelper';

const props = defineProps({
  macro: {
    type: Object,
    required: true,
  },
});

const labels = useMapGetter('labels/getLabels');
const teams = useMapGetter('teams/getTeams');
const agents = useMapGetter('agents/getAgents');

const getActionValue = (key, params) => {
  const actionsMap = {
    assign_team: resolveTeamIds(teams.value, params),
    add_label: resolveLabels(labels.value, params),
    remove_label: resolveLabels(labels.value, params),
    assign_agent: resolveAgents(agents.value, params),
    remove_assigned_agent: null,
    mute_conversation: null,
    snooze_conversation: null,
    resolve_conversation: null,
    remove_assigned_team: null,
    send_webhook_event: params[0],
    send_message: params[0],
    send_email_transcript: params[0],
    add_private_note: params[0],
  };
  return actionsMap[key] || '';
};

const resolvedMacro = computed(() => {
  return props.macro.actions.map(action => ({
    actionName: resolveActionName(action.action_name),
    actionValue: getActionValue(action.action_name, action.action_params),
  }));
});
</script>

<template>
  <div
    class="max-h-72 overflow-y-auto border-t border-n-weak bg-n-alpha-2 px-4 py-3 text-left rtl:text-right"
  >
    <ol class="space-y-3">
      <li
        v-for="(action, i) in resolvedMacro"
        :key="i"
        class="flex items-start gap-3"
      >
        <span class="flex size-5 shrink-0 items-center justify-center rounded-full bg-n-slate-4 text-xs font-medium text-n-slate-11">
          {{ i + 1 }}
        </span>
        <div class="min-w-0 flex-1">
          <p class="text-sm font-medium text-n-slate-12">
            {{ $t(`MACROS.ACTIONS.${action.actionName}`) }}
          </p>
          <p
            v-if="action.actionValue"
            class="mt-1 break-words text-xs text-n-slate-11"
          >
            {{ action.actionValue }}
          </p>
        </div>
      </li>
    </ol>
  </div>
</template>
